import { useNavigate } from 'react-router-dom';
import { useLearner } from '../../hooks/useLearner';
import { useSeriesList } from '../../hooks/useLibrary';
import BottomNav from '../../components/common/BottomNav';
import CloudBand from '../../components/common/CloudBand';
import s from './LibraryPage.module.css';

export default function LibraryPage() {
  const navigate = useNavigate();
  const { data: activeLearner } = useLearner();
  const childId = activeLearner?.id;

  const { data: seriesList = [], isLoading, error } = useSeriesList(childId);

  return (
    <div className={s.page}>
      <div className={s.hero}>
        <button className={s.backBtn} onClick={() => navigate('/bookshelf')} aria-label="Back to Bookshelf">
          ←
        </button>
        <h1 className={s.heroTitle}>Library</h1>
        <p className={s.heroSub}>Stories to explore</p>
        <CloudBand variant="cream" className={s.cloudBand} />
      </div>

      <div className={s.content}>
        {isLoading && (
          <div className={s.loadingState}>
            <span className={s.loadingDot} />
            <span className={s.loadingDot} />
            <span className={s.loadingDot} />
          </div>
        )}

        {error && (
          <div className={s.errorState}>
            <p>Couldn't load the library. Pull down to retry.</p>
          </div>
        )}

        {!isLoading && !error && seriesList.length === 0 && (
          <div className={s.emptyState}>
            <p className={s.emptyTitle}>Coming Soon</p>
            <p className={s.emptyBody}>New stories are on their way. Check back soon!</p>
          </div>
        )}

        {!isLoading && !error && seriesList.length > 0 && (
          <div className={s.seriesGrid}>
            {seriesList.map((series) => (
              <button
                key={series.id}
                className={s.seriesCard}
                onClick={() => navigate(`/library/${series.id}`)}
              >
                <div className={s.seriesCover}>
                  {series.cover_image_url ? (
                    <img src={series.cover_image_url} alt={series.name} className={s.coverImg} />
                  ) : (
                    <div className={s.coverPlaceholder}>
                      <span className={s.coverPlaceholderText}>
                        {series.name.charAt(0)}
                      </span>
                    </div>
                  )}
                  {series.episodes_read > 0 && series.episodes_total > 0 && (
                    <div className={s.progressPill}>
                      {series.episodes_read}/{series.episodes_total}
                    </div>
                  )}
                </div>
                <div className={s.seriesInfo}>
                  <p className={s.seriesName}>{series.name}</p>
                  {series.description && (
                    <p className={s.seriesDesc}>{series.description}</p>
                  )}
                  <p className={s.seriesMeta}>
                    {series.episodes_total} {series.episodes_total === 1 ? 'episode' : 'episodes'}
                    {series.free_episode_count > 0 && (
                      <> · {Math.min(series.free_episode_count, series.episodes_total)} free</>
                    )}
                  </p>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}
